export default "__VITE_ASSET__5ecd2d48__"